<template>
  <div v-show="!isHidePhoneOption">
    <m-loader :show="!demoInit" size="smBox" />
    <div v-show="!noPhoneOption">
      <b-form-select
        v-model="selectedPhoneOption"
        :disabled="disabled"
        v-show="demoInit"
        class="phone-select"
      >
        <b-form-select-option disabled value=""
          >Select Phone Option</b-form-select-option
        >
        <b-form-select-option
          v-for="item in phoneOptions"
          :key="item.value"
          :value="item.value"
        >
          {{
            item.desc +
            ((item.value === "2" || item.value === "3") && !isBusiness
              ? "*"
              : "")
          }}
        </b-form-select-option>
      </b-form-select>
      <div v-show="selectedPhoneOption == 2">
        <span class="phone-span" style="font-size: 10px; color: #e04557"
          >* Please note New York and Louisiana prohibit telemarketing during
          declared states of emergency.</span
        >
      </div>
      <div v-show="selectedPhoneOption == 3">
        <span class="phone-span" style="font-size: 10px; color: #e04557"
          >* Please note New York and Louisiana prohibit telemarketing during
          declared states of emergency.</span
        >
      </div>
      <div
        class="phone-span"
        v-show="(Object.keys(phoneOptions).length > 1) & !isBusiness"
        style="font-size: 10px"
      >
        &nbsp;&nbsp;&nbsp;&nbsp;* Phone numbers have been pre-scrubbed against
        the Do Not Call list.
      </div>
    </div>
    <p v-show="noPhoneOption">No Phone Option</p>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isBusiness() {
      return this.$store.getters["demo/isBusiness"];
    },
    selectedPhoneOption: {
      get() {
        return this.$store.state.order.PhoneOption;
      },
      set(val) {
        this.$store.commit("order/savePhoneOption", val);
      },
    },
    demoInit() {
      return this.$store.state.demo.isInit;
    },
    phoneOptions() {
      return this.$store.getters["demo/phoneOptions"];
    },
    noPhoneOption() {
      return this.$store.getters["demo/noPhoneOption"];
    },
    isHidePhoneOption() {
      return this.$store.getters["demo/isHidePhoneOption"];
    },
  },
};
</script>

<style scoped lang="scss">
.phone-span {
  font-style: italic;
}
.phone-select {
  width: 70%;
}

@media (max-width: 576px) {
  .or-s {
    width: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/demo/MPhoneOption.vue